export default __webpack_public_path__ + "../staticImages/packster_logo_eu_claim_neg_rgb.svg";